import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Globals } from '../../globals';
import { Observable } from 'rxjs';

@Injectable()
export class ReportService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
    * Get all reports
    */

    getReports() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/report/'
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        return this.http.get(url, {headers: requestHeaders, responseType: 'json'});
    }

    postReport(paramList) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/report/generateReport'
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const reportBody = new HttpParams()
            .set('reportBody', JSON.stringify(paramList));

        return this.http.post(url, reportBody, {headers: requestHeaders, responseType: 'json'});
    }

    validateReport(paramList) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/report/validateReport'
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const reportBody = new HttpParams()
            .set('reportBody', JSON.stringify(paramList));

        return this.http.post(url, reportBody, {headers: requestHeaders, responseType: 'json'});
    }

    getReportStream(uuid, suffix) : Observable<Blob> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/report/getReport?uuid=' + uuid + '&suffix=' + suffix;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        return this.http.get(url, {headers: requestHeaders, responseType: 'blob'});
    }

    /**
    * Get stored export format from cookie, default format should be PDF
    */
    getDefaultExportFormat() {      
        if (Cookie.check('exportFormat'))  {
            return Cookie.get('exportFormat');
        } else {
            return 'PDF';
        }        
    }

    /**
     * Set default export format
     * @param exportFormat 
     */
    setDefaultExportFormat(exportFormat) {
        Cookie.set(this.globals.clientId + '_exportFormat', exportFormat);
        return Cookie.get(this.globals.clientId + '_exportFormat');
    }
}
